import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AudioService {

  audio = new Audio('https://a7.asurahosting.com:6760/radio.mp3');
  isPlaying = false;
  fadeInterval: any;
  isFailed = false;
  errorMessage = '';

  constructor() {
    // Add event listeners to handle network disconnection or audio errors
    // this.audio.addEventListener('error', this.handleAudioError.bind(this));
    // this.audio.addEventListener('stalled', this.handleAudioError.bind(this)); // Detect internet disconnection
    // window.addEventListener('online', this.handleInternetReconnect.bind(this)); // Listen for the internet coming back online
  }

  playAudio() {
    this.audio.src = 'https://a7.asurahosting.com:6760/radio.mp3'; // Set the source
    this.audio.load(); // Reload the stream
    this.audio.volume = 0; // Start at volume 0 for smooth fade-in
    this.isFailed = false;
    this.errorMessage = '';
    this.audio.play().catch((error) => {
      if (this.audio.error) {
        this.isFailed = true;
        this.isPlaying = false;
        this.errorMessage = 'Stream failed to load. Check your connection.';
        clearInterval(this.fadeInterval);
      }
    });
    this.fadeIn();
    this.isPlaying = true;

    Swal.fire({
      title: '😍 تم تشغيل الراديو بنجاح 🎶',
      toast: true,
      timer: 2000,
      position: 'top',
      icon: 'success',
      showConfirmButton: false
    });

  }

  pauseAudio() {
    this.fadeOut(() => {
      this.audio.pause();
      this.audio.load(); // Reload to reset the stream
    });
    this.isPlaying = false;

    Swal.fire({
      title: '⛔ تم إيقاف تشغيل الراديو',
      toast: true,
      timer: 2000,
      position: 'top',
      icon: 'warning',
      showConfirmButton: false
    });
    
    
  }

  fadeOut(callback: Function) {
    clearInterval(this.fadeInterval);
    let volume = this.audio.volume;
    this.fadeInterval = setInterval(() => {
      if (volume > 0) {
        volume = Math.max(0, volume - 0.05); // Decrease volume smoothly
        this.audio.volume = volume;
      } else {
        clearInterval(this.fadeInterval);
        callback(); // Execute pause and reset action
      }
    }, 100); // Adjust the speed of fading
  }

  fadeIn() {
    clearInterval(this.fadeInterval);
    let volume = this.audio.volume;
    this.fadeInterval = setInterval(() => {
      if (volume < 1) {
        volume = Math.min(1, volume + 0.05); // Increase volume smoothly
        this.audio.volume = volume;
      } else {
        clearInterval(this.fadeInterval);
      }
    }, 100); // Adjust the speed of fading
  }

  // handleAudioError(event: Event) {
  //   if (this.isPlaying && (this.audio.error || event.type === 'stalled')) {
  //     this.isFailed = true;
  //     this.errorMessage = 'Internet connection lost. Stream stopped.';
  //     this.isPlaying = false;
  //     clearInterval(this.fadeInterval); // Clear any fade intervals
  //     this.audio.pause(); // Stop audio if there's a network issue
  //     this.audio.src = ''; // Clear the source
  //   }
  // }

  // handleInternetReconnect() {
  //   if (this.isFailed && !this.isPlaying) {
  //     this.playAudio(); // Attempt to play again when online
  //   }
  // }

}
